import React from 'react';
import { useStore } from 'zustand';

import {
  InventoryTabItemName,
  inventoryStore,
} from '../../../../../InventoryStore';
import { useInventoryState, useReadOnlyRowConfig } from '../../../../../hooks';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { PackDetails } from '../../../../../utils/packs';
import { PackType } from '../../../../Header/ActionsBar/InventoryToggle/InventoryToggle';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { LabelValueCell } from '../../../../Table/Cells/LabelValueCell/LabelValueCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';

const PackStockRowComponent: React.FC<{ packId: number }> = ({ packId }) => {
  const packType = useStore(inventoryStore, (state) => state.packType);

  const { inventoryPacks, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Packs
  );

  const { endOfSaleDate } = useInventoryState();

  if (!inventoryPacks) {
    return null;
  }

  return (
    <TableRow>
      {packType === PackType.NIGHT_STAY ? (
        <LabelCell
          label="Stock on sale"
          hasInfoIcon
          tooltipTitle="Total stock on sale based on Rooms and Activities & amenities stock included in this package."
        />
      ) : (
        <LabelCell label="Stock on sale" />
      )}
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${packId}`];
        const stockOnSaleFieldName = [...fieldName, 'stockOnSale'];
        const isGrayed =
          isDatePast(dateKey) || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: PackDetails) => {
              if (!values) {
                return null;
              }

              return (
                <LabelValueCell
                  value={values?.stockOnSale ?? '∞'}
                  date={dateKey}
                  name={stockOnSaleFieldName}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const PackStockRow = React.memo(PackStockRowComponent);
